<script>
export default {
  name: 'LinkCellRenderer',
  computed: {
    label: ({ params }) => params.label ?? params.value,
    target: ({ params }) => params.newTab ? '_blank' : '_self',
    to: ({ params }) => params.to,
    isExternal: ({ params }) => typeof params.to === 'string' && params.to.startsWith('http')
  }
}
</script>

<template>
  <a
    v-if="to && isExternal"
    class="text-decoration-underline cursor-pointer"
    :href="to"
    :target="target"
  >
    {{ label }}
  </a>
  <router-link
    v-else-if="to"
    class="text-decoration-underline cursor-pointer"
    :target="target"
    :to="to"
  >
    {{ label }}
  </router-link>
  <span v-else>{{ label }}</span>
</template>
